<div class="table-container">
    <table aria-label="basic-table" class="table align-middle mb-0">
        <thead class="bg-light">
            <tr>
                <ng-container *ngFor="let elem of tableKeys">
                    <th scope="col">
                        {{elem?.label}}
                    </th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let item of dataset">
                <tr>
                    <ng-container *ngFor="let elem of tableKeys">
                        <td [ngClass]="[elem?.type === 'TOOLTIP' ? 'ellipsis-value' : '', elem?.class !== undefined ? elem?.class : '']">
                            <ng-container [ngSwitch]="elem?.type">
                                <ng-container *ngSwitchCase="'ACTION_ICON'">
                                    <ng-container *ngIf="item[elem?.showIconFieldName]">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <mat-icon class="table-action-icon align-middle" [matTooltip]="elem?.tooltipText" [color]="elem?.color" (click)="onButtonClick(item, elem)">{{elem?.actionIcon}}</mat-icon>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="'IMAGE'">
                                    <div class="d-flex align-items-center">
                                        <img [src]="getCompanyImage(item)" alt="company-logo" class="company-logo-img">
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'BADGE'">
                                    <span class="badge" [ngClass]="getStatusBadge(item)">
                                        {{getOperationStatusLabel(item)}}
                                    </span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'GENERIC_BADGE'">
                                    <span class="badge" [ngClass]="getGenericStatusColor(item, elem)">
                                        {{getGenericStatusLabel(item, elem)}}
                                    </span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'TOOLTIP'">
                                    <span class="table-value" matTooltip="{{ getValue(item, elem) }}" matTooltipPosition="above">{{ getValue(item, elem) }}</span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'RADIO'">
                                    <mat-radio-button
                                        (change)="selectItem(item)"
                                        (click)="$event.stopPropagation()"
                                        [checked]="radioSelectionGroup === item.fundCode"
                                        name="rowSelection"
                                    >
                                    </mat-radio-button>
                                </ng-container>
                                <!-- CHECKBOX -->
                                <ng-container *ngSwitchCase="'CHECKBOX'">
                                    <mat-checkbox
                                    [(ngModel)]="item[elem?.key]" [disabled]="item[elem?.isDisabledKey] || false"></mat-checkbox>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <span class="table-value" [ngClass]="elem.css" >{{ getValue(item, elem) }}</span>
                                </ng-container>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
